import { AmberHoc, AmberHocProps } from '../../../util';
import {
  UpdateWeeklyGrainEmailScheduleMutation as Result,
  UpdateWeeklyGrainEmailScheduleMutationVariables as Variables,
  withUpdateWeeklyGrainEmailSchedule as HOC,
} from '../__generated';
import { GraphQLErrors } from './error';

export type WithUpdateWeeklyGrainEmailScheduleHocChildProps = {
  updateWeeklyGrainEmailSchedule: (
    variables: Variables
  ) => Promise<Result['updateWeeklyGrainEmailSchedule']>;
};

export const withUpdateWeeklyGrainEmailScheduleHoc: AmberHoc<
  {},
  WithUpdateWeeklyGrainEmailScheduleHocChildProps
> = (component) =>
  HOC<
    AmberHocProps<{}, WithUpdateWeeklyGrainEmailScheduleHocChildProps, typeof component>,
    WithUpdateWeeklyGrainEmailScheduleHocChildProps
  >({
    options: { errorPolicy: 'all' },
    props: (props) => {
      const { mutate } = props;
      return {
        updateWeeklyGrainEmailSchedule: async (variables) => {
          if (!mutate) {
            throw new Error('Unexpected UI error');
          }

          const result = await mutate({ variables });

          if (!result) {
            throw new Error('Unexpected server response');
          }

          const { errors, data } = result;
          if (errors) {
            throw new GraphQLErrors(errors);
          }
          if (!data) {
            throw new Error('Unexpected server response');
          }
          return data.updateWeeklyGrainEmailSchedule;
        },
      };
    },
  })(component as any);
